import { BaseInputFilter } from "domain/models/base-input-filter";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { ITimesheetReportRepository } from "domain/contracts/timesheet-report.contract";
import { TimesheetReport } from "domain/entities/timesheet-report";

class TimesheetReportRepository implements ITimesheetReportRepository {
  async getTimesheetReportByEmployee(
    id: string,
    filter?: BaseInputFilter
  ): Promise<Message<TimesheetReport>> {
    const response = await httpClient.get(`/report/detailedEmployee/${id}`, {
      params: filter,
    });
    return response.data;
  }

  async getTimesheetReportAllEmployees(
    month: string,
    year: string,
    filter?: BaseInputFilter
  ): Promise<Message<TimesheetReport[]>> {
    const response = await httpClient.get(
      `/report/detailedEmployee/${month}/${year}`,
      { params: filter }
    );
    return response.data;
  }
}

export default new TimesheetReportRepository();
